export default {
  PAGINATION_ARROWS: {
    FIRST: require('./arrow_first.svg'),
    LAST: require('./arrow_last.svg'),
    NEXT: require('./arrow_next.svg'),
    PREVIOUS: require('./arrow_previous.svg'),
  },
};
